import { getFeature, isFeature } from 'Cloud/Application/FeaturesEs6';

/** CLOUDWEB-19520 Выкидывать из сага очереди заглушку 3промо, если 3промо в этот момент ничего не показывает */
export const prune3promoFakeItemFromSagaQueue: boolean = getFeature('3promo-prune-form-saga-queue');

/** CLOUDWEB-19520 С каким интервалом чекать очередь */
export const NEWPROMO_MANAGER_CHECK_INTERVAL: number = getFeature('newpromo-manager-check-interval') || 5 * 60 * 1000;

/** CLOUDWEB-19520 Не лочить сага очередь если в ней осталась одна промка.
 * Без фичи сага бесконечно ждет когда покажется последняя промка из очереди.
 * Это ломает промки, которые могут несколько раз за сессию покзаываться (например рекламный фулскрин)
 * По сути, это отмена правок из https://jira.vk.team/browse/CLOUDWEB-17305
 */
export const NO_LOCK_LAST_SAGA_PROMO: boolean = getFeature('saga-promos-no-lock-last-promo');

/** CLOUDWEB-19520 Таймаут на заполнение сага очереди
 * Без фичи сага бесконечно ждет когда прогрузится квота при ините некоторых промок на анонимном юзере
 * Это ломает очередь и не позволяет показывать промки анонам
 */
export const FILL_SAGA_PROMO_QUEUE_TIMEOUT: number | undefined = getFeature('fill-saga-promo-queue-timeout');

/** CLOUDWEB-19617
 * Не показывать redux промки, если показали 3promo промку
 */
export const disableReduxPromoAfter3Promo: boolean = getFeature('disable-redux-promo-after-3promo');

export const reduxPromoDebug = isFeature('redux-promo-debug');

export const update3PromoAtRouteChange = isFeature('update-3promo-at-route');
